<template>
  <div
    :dependentComputedProps="{
      isSessionPresent,
    }"
  >
    <div class="pb24 dt-mb64" id="whatMakesUS" ref="whatMakesUS">
      <VueLottiePlayer
        name="confettiAnim"
        width="100%"
        height="100%"
        @animControl="onAnimationCreated"
        :path="getLottie"
        :autoplay="false"
        v-if="getLottie"
      />
      <img
        :src="getBgImage"
        class="width100"
        title="What makes us different"
        v-else-if="getBgImage"
      />
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { keyMapsAction } from "../helpers/storeKeys";
import { clientPlatform } from "../config/apiEndpoints";

export default {
  name: "WhatMakesUsDifferent",
  components: {
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
  },
  props: ["moduleProps"],
  data() {
    return {
      clientPlatform,
      animationInstance: {},
      modulePropsData: {},
      inView: false,
      observer: null,
      sessionDependedMethodsProcessed: false,
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    this.showArea();
  },
  unmounted() {
    if ("IntersectionObserver" in window && this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    showArea() {
      if ("IntersectionObserver" in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.playAnimation();
              this.observer.disconnect();
            }
          },
          {
            root: null, // viewport
            threshold: 1,
          }
        );
        this.observer?.observe(document.querySelector("#whatMakesUS"));
      }
    },
    onAnimationCreated(instance) {
      this.animationInstance = instance;
      instance?.stop();
    },
    playAnimation() {
      setTimeout(() => {
        if (
          this.animationInstance &&
          typeof this.animationInstance.play == "function"
        ) {
          this.animationInstance.play();
        }
      }, 400);
    },
  },
  computed: {
    getBgImage() {
      return this.$store.state?.BannerOffers?.whatmakeUsDiff?.imgBig;
    },
    getLottie() {
      return this.$store.state?.BannerOffers?.whatmakeUsDiff?.attributes
        ?.lottie;
    },
    isSessionPresent() {
      let isSessionP = this.$store.state.Auth.isSessionPresent;
      if (isSessionP && !this.sessionDependedMethodsProcessed) {
        this.$store.dispatch(
          keyMapsAction.WHAT_MAKES_US_DIFF,
          "WhatMakesUsDiff"
        );
        this.sessionDependedMethodsProcessed = true;
      }
      return isSessionP;
    },
  },
};
</script>
